import { render, staticRenderFns } from "./CurrentScreenshot.vue?vue&type=template&id=7c3b8c2e&"
import script from "./CurrentScreenshot.vue?vue&type=script&lang=js&"
export * from "./CurrentScreenshot.vue?vue&type=script&lang=js&"
import style0 from "./CurrentScreenshot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports